import { nameof } from "ts-simple-nameof";
import { DefaultButton } from "../../components/button/defaultButton/DefaultButton";
import { HiddenField } from "../../components/forms/inputs/hiddenField/HiddenField";
import styles from "./NomenclatureListPageDialog.module.scss";
import {
  FieldValues,
  Path,
  SubmitHandler,
  useFormContext,
} from "react-hook-form";
import { useEffect } from "react";

interface INomenclatureListPageDialogProps<
  TFormModel extends FieldValues,
  TItemModel extends Partial<TFormModel>
> {
  items?: TItemModel[];
  itemIdToUpdate?: number | null;
  formFields: React.ReactNode;
  isLoading: boolean;
  onSubmit: SubmitHandler<TFormModel>;
}

export const NomenclatureListPageDialog = <
  TFormModel extends FieldValues,
  TItemModel extends Partial<TFormModel>
>({
  formFields,
  items,
  itemIdToUpdate = null,
  isLoading,
  onSubmit,
}: INomenclatureListPageDialogProps<TFormModel, TItemModel>) => {
  const form = useFormContext<TFormModel>();

  const itemToUpdate = items?.find((x) => x.id === itemIdToUpdate);

  useEffect(() => {
    if (itemToUpdate) {
      (Object.keys(form.getValues()) as Path<TFormModel>[]).forEach((key) => {
        const value = (itemToUpdate as any)[key];
        if (value !== undefined) {
          form.setValue(key, value);
        }
      });
    }
  }, [itemToUpdate]);

  if (itemIdToUpdate && !itemToUpdate) {
    return;
  }

  const buttonLabel = !!itemIdToUpdate ? "Запази" : "Добави";
  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className={styles.root}>
      <div className={styles.root_fields}>{formFields}</div>
      <HiddenField name={nameof<TFormModel>((x) => x.id)} />
      <div className={styles.root_buttons}>
        <DefaultButton label={buttonLabel} type="submit" loading={isLoading} />
      </div>
    </form>
  );
};
